/* eslint-disable import/no-named-as-default-member */
import friendApi from 'lib/api/friends';
import create from 'zustand';
import { IContactSyncStatusStore } from './types';

const contactSyncStore = create<IContactSyncStatusStore>((set) => ({
  status: 'CONTACT_STATUS_TYPE_NOT_SYNCED',
  total: 0,
  fetchStatus: () => {
    friendApi.getContactSyncStatus()
      .then((res) => {
        const { data: { status, total } } = res.data;
        set({
          status,
          total,
        });
      })
      .catch(() => {});
  },
}));

export default contactSyncStore;
